import { LitElement, html, utils } from '@hh/global.js'
const { prefersReducedMotion } = utils

class HHProductAccordions extends LitElement {
  static get properties() {
    return {
      openIndex: { type: Number, reflect: true, attribute: 'open-index' },
    }
  }

  constructor() {
    super()

    this.openIndex = -1

    this.readMore = this.querySelectorAll('.js-read-more')
    this.readMore.forEach((button) => {
      button.addEventListener('click', () => {
        this.toggleReadMore(button, true)
      })
    })

    this.contents = this.querySelectorAll('.js-accordion-content')
  }

  toggleReadMore(button, isShort) {
    const currentAccordion = button.closest('.accordion')
    const contents = currentAccordion.querySelector('.js-accordion-content')

    isShort = !isShort
    if (isShort) {
      currentAccordion.querySelector(
        '.js-product-content-short'
      ).style.display = 'block'
      currentAccordion.querySelector('.js-product-content-long').style.display =
        'none'
    } else {
      if (button) {
        button.style.display = 'none'
      }
      currentAccordion.querySelector(
        '.js-product-content-short'
      ).style.display = 'none'
      currentAccordion.querySelector('.js-product-content-long').style.display =
        'block'
      contents.style.maxHeight = contents.scrollHeight + 'px'
    }
  }

  scrollIntoViewIfNeeded(element) {
    const rect = element.getBoundingClientRect()
    const isInViewport =
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)

    if (!isInViewport) {
      element.scrollIntoView()
    }
  }

  firstUpdated() {
    const triggers = this.querySelectorAll('.js-accordion-trigger')
    triggers.forEach((trigger, index) => {
      trigger.addEventListener('click', () => {
        if (this.openIndex === index) {
          this.openIndex = -1
        } else {
          this.openIndex = index
          // 0.3s delay is required to allow accordion closing transition to finish before calculating current position
          setTimeout(() => {
            this.scrollIntoViewIfNeeded(trigger)
          }, 300)
        }
        this.requestUpdate()
      })
    })
  }

  updated() {
    const triggers = this.querySelectorAll('.js-accordion-trigger')
    this.contents.forEach((content, index) => {
      if (index === this.openIndex) {
        content.classList.add('open')
        content.style.display = 'block'
        content.style.maxHeight = content.scrollHeight + 'px'
        triggers[index].classList.add('open')
        triggers[index].setAttribute('aria-expanded', true)
      } else {
        content.classList.remove('open')
        content.style.maxHeight = null
        if (prefersReducedMotion()) {
          content.style.display = 'none'
        }

        triggers[index].classList.remove('open')
        triggers[index].setAttribute('aria-expanded', false)
      }
    })
  }

  render() {
    return html` <slot></slot> `
  }
}

customElements.define('hh-product-accordions', HHProductAccordions)
